import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiNieuwegeinRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="Nieuwegein"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={65.00}
      distance="55 km"
      duration="45-50 minuten"
    />
  );
}
